export default __webpack_public_path__ + "static/media/spanovanje.161f7805.png";